import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';

import { environment } from './../../environments/environment';
import { Argomento } from '../models/Argomento';

@Injectable()
export class ArgomentoService {
  selectedCodice: string;

  get selected(): string {
    return this.selectedCodice;
  }
  set selected(codice: string) {
    this.selectedCodice = codice;
  }

  constructor(private http: Http) { }

  search(q): Observable<any> {
    return this.http.post(environment.server.url + '/argomento/search', { q: q })
      .map(response => response.json())
  }
}



// WEBPACK FOOTER //
// ./src/app/services/argomento.service.ts